import React, { Component } from 'react';
import { actions } from 'react-redux-form';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { MAX_LENGTH } from "../../../../../../constants/external-constants";
import { InputFieldFloatingLabel as InputField, SelectFieldFloatingLabel as Select } from '../../../../../common/custom-form/select-filter.component';
import CustomSearchableSelectWrapper from '../../../../../common/custom-form/custom-searchable-select-wrapper.component';
import Translation from "../../../../../common/translation/translation.component";
import DATEPICKER_OR from "../../../../../common/custom-form/custom-date-picker.component";
import { TRANSLATIONS as translation } from '../../../../../../utils/constant.utils';
import { glCodeDetailsActions } from "../../../../../../store/external/finance/glcode-details/gl-code-details.reducer"
import { Loading } from "../../../../../common/loading";

class GLCodeForm extends Component {
    constructor(props) {
        super(props);

        this.ConfirmationModal = React.createRef();

        this.state = {
            saveModal: {
                title: "",
                messageBody: "",
                confirmAction: () => { }
            },
            saveNotif: {
                show: false,
                title: "",
                message: ""
            },
            isLoading: true
        }
    }

    async componentDidMount() {
        const { getGlCodeStatusDropdown, getGlCodeDetailsForm, glCodeId, isNew } = this.props;
        if (!isNew) {
            await getGlCodeDetailsForm(glCodeId);
        }
        await getGlCodeStatusDropdown();
    }

    componentWillUnmount() {
        this.props.resetNewGlCodeForm();
        this.props.resetGlCodeDetailsForm();
    }

    toLocaleLanguage = (key) => {
        const { locale } = this.props;
        if (locale === null || locale === '' || locale === undefined)
            return translation[translation['defaultLocaleLanguage']][key];
    
        return translation[locale][key];
    }

    render() {
        const { glCodeDetailsForm, glCodeDetails } = this.props;

        if (glCodeDetails.fetchFormInProgress) {
            return <Loading />
        }

        return(
            <div className="cost-allocation-form message-form-body">
                <InputField
                    className="form-control"
                    type="text"
                    label={<Translation translationKey={'gl_code'} />}
                    value={glCodeDetailsForm.glCode}
                    fieldProp='glCodeDetailsForm.glCode'
                    maxLength={MAX_LENGTH.limit_100}
                    placeholder={"Enter text here..."}
                    requiredField={true}   
                />
                
                <InputField
                    className="form-control"
                    type="text"
                    label={<Translation translationKey={'name'} />}
                    value={glCodeDetailsForm.glCodeName}
                    fieldProp='glCodeDetailsForm.glCodeName'
                    maxLength={MAX_LENGTH.limit_100}
                    placeholder={"Enter text here..."}
                />
                <InputField
                    className="form-control"
                    type="text"
                    label={<Translation translationKey={'description'} />}
                    value={glCodeDetailsForm.description}
                    fieldProp='glCodeDetailsForm.description'
                    maxLength={MAX_LENGTH.limit_255}
                    placeholder={"Enter text here..."}
                />
                
                <Select
                    className="form-select required"
                    label={<Translation translationKey={'status_capital'} />}
                    value={glCodeDetailsForm.status}
                    options={glCodeDetails.glCodeStatusOptions}
                    placeholder={`${this.toLocaleLanguage('select_placeholder')}`}
                    fieldProp='glCodeDetailsForm.status'
                    requiredField={true}
                    optionLabelKey={{
                        Key: "Key",
                        Value: "Value"
                    }}
                />  
                
                <DATEPICKER_OR
                        dateOnly={true}
                        label={<Translation translationKey={'valid_from_capital'} />}
                        startDate={glCodeDetailsForm.validFromDate}
                        selectedDate={(date) => this.props.FormChange("glCodeDetailsForm.validFromDate", date)}
                        placeholder={`${this.toLocaleLanguage('select_date')}`}
                        maxDate={glCodeDetailsForm.validToDate}
                    />
                <DATEPICKER_OR
                        dateOnly={true}
                        label={<Translation translationKey={'valid_to_capital'} />}
                        startDate={glCodeDetailsForm.validToDate}
                        selectedDate={(date) => this.props.FormChange("glCodeDetailsForm.validToDate", date)}
                        placeholder={`${this.toLocaleLanguage('select_date')}`}
                        minDate = {glCodeDetailsForm.validFromDate}
                        isDisable ={false}
                    />
            </div>
        )
    }
}

export default connect(
    state => {
        const {
            glCodeDetails
            , translation
            , form: { forms: { glCodeDetailsForm: { $form } } }
        } = state;
        const { glCodeDetailsForm } = state.form;

        return {
            glCodeDetails
            , glCodeDetailsForm
            , translation
            , $form
        };
    },
    dispatch => ({
        ...bindActionCreators(
            Object.assign({}, glCodeDetailsActions),
            dispatch
        ),
        FormChange: (model, value) => {
            dispatch(actions.change(model, value))
        }
    })
)(GLCodeForm);